import React from 'react';
import { Input, Select, Icon, Row, Col } from 'antd';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={6}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.nombre} //STATE PROPERTY
                            onChange={e => this.props.onChange("nombre", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por nombre"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={6}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.Establecimiento ?
                                    { key: this.props.filter.Establecimiento } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Establecimiento" />}
                            onChange={(option) => this.props.onChange("Establecimiento", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.listaEstablecimiento.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={6}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idTipoCaja ?
                                    { key: this.props.filter.idTipoCaja } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Tipo" />}
                            onChange={(option) => this.props.onChange("idTipoCaja", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.tipos.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={6}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.estado ?
                                    { key: this.props.filter.estado } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por estado" />}
                            onChange={(option) => this.props.onChange("estado", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.estados.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Filters;